module.exports = __webpack_public_path__ + "media/glassDoorHandleSmartLock.9caa5202.mp4";